/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from 'src/components/common/cpds/utils/cpds-utils';
import { checkValue } from 'src/components/common/helper';

export const HeroBackgroundOverlay = styled.div.attrs({
  className: 'v3-hero-gradient-module',
})<{ color?: string; opacity?: number }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    opacity,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      position: absolute;
      height: 100%;
      width: 100%;
      z-index: 2;
      background-color: ${checkValue(color) ? color : token?.travel_hub_hero_overlay_color || '#000000'};
      opacity: ${checkValue(opacity) ? opacity : token?.travel_hub_hero_overlay_opacity || 0.4};
    `;
  }}
`;
